//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    initiallyOpen: {
      type: Boolean,
      default: false,
    },
    question: {
      type: String,
      required: true
    },
    answer: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isOpen: this.initiallyOpen,
    }
  },
  methods: {
    toggleOpen () {
      this.isOpen = !this.isOpen
    }
  }
}
